import { render, staticRenderFns } from "./footer-nav.vue?vue&type=template&id=58767113&scoped=true&"
import script from "./footer-nav.vue?vue&type=script&lang=js&"
export * from "./footer-nav.vue?vue&type=script&lang=js&"
import style0 from "./footer-nav.vue?vue&type=style&index=0&id=58767113&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58767113",
  null
  
)

export default component.exports